import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import Contact from "./pages/Contact";
import VentesPrivees from "./pages/VentesPrivees";
import APropos from "./pages/APropos";
import GuideTailles from "./pages/GuideTailles";
import FAQ from "./pages/FAQ";
import Livraison from "./pages/Livraison";
import Account from "./pages/Account";
import OrderTracking from "./pages/OrderTracking";
import Legal from "./pages/Legal";
import CjCatalog from "./pages/admin/CjCatalog";
import MyProducts from "./pages/admin/MyProducts";
import ImportWizard from "./pages/admin/ImportWizard";
import SyncDashboard from "./pages/admin/SyncDashboard";
import Orders from "./pages/admin/Orders";
import "./App.css";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/boutique" element={<Shop />} />
        <Route path="/nouveautes" element={<Shop mode="new" />} />
        <Route path="/promotions" element={<Shop mode="promo" />} />
        <Route path="/produit/:slug" element={<ProductDetail />} />
        <Route path="/commande" element={<Checkout />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ventes-privees" element={<VentesPrivees />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/guide-des-tailles" element={<GuideTailles />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/livraison-retours" element={<Livraison />} />
        <Route path="/compte" element={<Account />} />
        <Route path="/compte/commandes/:orderNumber" element={<OrderTracking />} />
        <Route path="/cgv" element={<Legal type="cgv" />} />
        <Route path="/mentions-legales" element={<Legal type="mentions" />} />
        <Route path="/confidentialite" element={<Legal type="confidentialite" />} />
        <Route path="/cookies" element={<Legal type="cookies" />} />
        <Route path="/admin" element={<Navigate to="/admin/cj-catalog" replace />} />
        <Route path="/admin/cj-catalog" element={<CjCatalog />} />
        <Route path="/admin/products" element={<MyProducts />} />
        <Route path="/admin/products/import" element={<ImportWizard />} />
        <Route path="/admin/sync-dashboard" element={<SyncDashboard />} />
        <Route path="/admin/orders" element={<Orders />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
